import React from "react"
import { Link } from "gatsby"

const BtnPrevious = ({ previous }) => (
  <Link
    className="items-center my-16 uppercase flex justify-start"
    to={previous.slug}
    rel="prev"
  >
    <span className="mr-2 font-sans">←</span> {previous.title}
  </Link>
)

const BtnNext = ({ next }) => (
  <Link
    className="items-center my-16 uppercase flex justify-end"
    to={next.slug}
    rel="next"
  >
    {next.title} <span className="ml-2 font-sans">→</span>
  </Link>
)

const Footer = ({ previous, next }) => {
  return (
    <div className="body section">
      <div className="w-full font-heading">
        {previous && <BtnPrevious previous={previous} />}
        {next && <BtnNext next={next} />}
      </div>
    </div>
  )
}

export default Footer
